import { AnimationFeature, MotionConfig } from 'framer-motion';
import { h } from 'preact';
import { Router } from 'preact-router';
import GettingStarted from './routes/GettingStarted/GettingStarted';

// Code-splitting is automated for `routes` directory
import Home from './routes/Home/Home';
import './style';

const App = () => (
  <div id="app">
    <MotionConfig features={[AnimationFeature]}>
      <Router>
        <Home path="/" />
        <GettingStarted path="/welcome" />
      </Router>
    </MotionConfig>
  </div>
);

export default App;
